module.exports = __webpack_public_path__ + "img/shou.210aea04.png";